import { CanUpdateTripOutput } from '@allocab/allocab-passenger-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { passengerApi } from '../services/network/Api';

type Input = { jwtToken: string; key: string };

const fetchAnonymousCanUpdateTrip = ({ key, jwtToken }: Input) =>
  passengerApi.get<void, CanUpdateTripOutput>(`anonymous/v1/${key}/can-update`, undefined, {
    headers: { Authorization: `Bearer ${jwtToken}` },
  });

export const useFetchAnonymousCanUpdateTrip = ({ key, jwtToken }: Input) =>
  useQuery(queryKeys.user.fetchCanUpdateTrip(key), () => fetchAnonymousCanUpdateTrip({ key, jwtToken }));
